import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideOAuthClient, OAuthService, AuthConfig } from 'angular-oauth2-oidc';

import { routes } from './app.routes';
import { provideDesignAngularKit } from 'design-angular-kit';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.issuer,
  redirectUri: environment.redirect_url,
  clientId: environment.client_id,
  responseType: 'code',
  scope: 'openid profile email internal_login',
  strictDiscoveryDocumentValidation: false,
  postLogoutRedirectUri: environment.redirect_url
};

function initializeOAuth(oauthService: OAuthService): () => Promise<void> {
  return () => {
    oauthService.configure(authConfig);
    return oauthService.loadDiscoveryDocumentAndTryLogin().then(() => { });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideDesignAngularKit(),
    provideHttpClient(withInterceptorsFromDi()),
    provideOAuthClient({
      resourceServer: {
          allowedUrls: [
            'https://apim.si-cot.atenainformatica.it',
            'https://api.si-cot.atenainformatica.it',
          ],
          sendAccessToken: true
      }
    }),
  {
    provide: APP_INITIALIZER,
    useFactory: initializeOAuth,
    deps: [OAuthService],
    multi: true
  }
  ]
};
